import React, { useEffect, useState } from 'react';
import { connect, useSelector } from 'react-redux';
import { useLocation, useNavigate } from 'react-router-dom';
import PropTypes from 'prop-types';
import { PDFExport, savePDF } from '@progress/kendo-react-pdf';
import { useTranslation } from 'react-i18next';
import { Card, CardBody, CardTitle, Col, Container, Row } from 'reactstrap';
import Notification from 'rc-notification';
import TextField from '@material-ui/core/TextField';
import * as XLSX from 'xlsx';
import SmallLoader from '../../../shared/components/SmallLoader';
import OrderTable from './OrderTable';
import { getOrdersData, handleLoader, handleTableLoader } from '../../../redux/actions/OrderAction';
import { getProducteDetails } from '../../../redux/actions/productAction';
import { vendorNameMapping } from '../helper'
import history from '../../App/History';

const Order = ({ dispatch, vendor }) => {
  const { t } = useTranslation('common');
  const navigate = useNavigate();
  const { orderData, isLoading, salesChannelFilterData, productData, isTableLoading } = useSelector(
    ({ OrderReducer, marketPlaceReducer, productReducer }) =>
    ({
      orderData: OrderReducer?.[vendor]?.orderData,
      isLoading: OrderReducer?.[vendor]?.isLoading,
      isTableLoading: OrderReducer?.[vendor]?.isTableLoading,
      salesChannelFilterData: marketPlaceReducer.salesChannel,
      productData: productReducer.productData
    }),
  );
  const skuOption = [];
  const productNameOptions = [];
  const [orderdata, setData] = useState([]);
  const [productdata, setProductData] = useState([]);
  const [searchAmazonOrderId, setAmazonOrderId] = useState("");
  const [searchBuyerName, setBuyerName] = useState("");
  const [searchSKU, setSku] = useState("");
  const [searchProductName, setProductName] = useState("");

  console.log({ data: orderData?.modal?.data })

  const callApi = ({ opage, opageSize }) => {
    dispatch(handleTableLoader(true, vendor))
    dispatch(getOrdersData({
      amazonOrderId: searchAmazonOrderId,
      name: searchBuyerName,
      sku: searchSKU || "",
      productName: searchProductName || "",
      page: opage,
      pageSize: opageSize,
      vendor
    }));
  }

  const handleApplySearch = () => {
    callApi({ opage: "0", opageSize: "250" })
  }

  const uploadExcel = () => {
    console.log('')
    navigate('/upload/order')
  }

  // Excel export function using XLSX
  const exportToExcel = () => {
    if (!orderdata || !orderdata.length) {
      console.log('No data to export');
      return;
    }

    // Define the columns and their mapping
    const excelColumns = [
      { header: 'Amazon OrderID', key: 'amazonOrderId' },
      { header: 'Buyer Name', key: 'buyerName' },
      { header: 'SKU', key: 'sku' },
      { header: 'Product Name', key: 'productName' },
      { header: 'Quantity', key: 'quantityShipped' },
      { header: 'Price', key: 'itemPrice' },
      { header: 'Currency', key: 'currency' },
      { header: 'Carrier', key: 'carrier' },
      { header: 'Tracking Number', key: 'trackingNumber' },
      { header: 'Sales Channel', key: 'salesChannel' },
      { header: 'Purchase Date', key: 'purchaseDate' },
      { header: 'Shipment Date', key: 'shipmentDate' }
    ];

    // Prepare data for export
    const worksheetData = orderdata.map(row => {
      const exportRow = {};
      excelColumns.forEach(col => {
        exportRow[col.header] = row[col.key] || '';
      });
      return exportRow;
    });

    // Create worksheet
    const worksheet = XLSX.utils.json_to_sheet(worksheetData);
    
    // Set column widths for better formatting
    const columnWidths = excelColumns.map(() => ({ wch: 15 }));
    worksheet['!cols'] = columnWidths;

    // Create workbook
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Orders");

    // Generate filename
    const filename = `${vendorNameMapping[vendor]} Orders.xlsx`;
    
    // Save file
    XLSX.writeFile(workbook, filename);
  };

  const container = React.useRef(null);
  const exportToPDF = () => {
    // console.log('Hello')
    Notification.newInstance({}, (notification) => {
      notification.notice({
        content: 'PDF loading......',
        duration: 5,
        style: {top: 120, fontWeight: "bold"},
        maxCount: 10
      });
    });
    const dvTb = document.getElementById('dvTable');
    dvTb.style.display = "none";  
    const element = container.current || document.body;
    
    savePDF(element, {
      paperSize: "auto",
      Header: "test",
      margin: { left: "1cm", top: "1cm", right: "1cm", bottom: "1cm" },
     // margin: "2cm",
     // forcePageBreak: ".page-break",
    //   landscape: true,
    //  multiPage: true,
      fileName: `${vendorNameMapping[vendor]} Orders Report ${new Date().getFullYear()}`,
    })
    dvTb.style.display = "block";  
  }

  const changeSkuFilter = (event) => {
    setSku(event.target.value);
  };

  const changePNameFilter = (event) => {
    setProductName(event.target.value)
  };

  useEffect(() => {
    dispatch(handleLoader(true, vendor));
    callApi({ opage: "0", opageSize: "250" })
    dispatch(getProducteDetails());
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    setData(orderData?.modal?.data || []);
  }, [orderData]);

  useEffect(() => {
    setProductData(productData && productData.modal && productData.modal.data || []);
  }, [productData]);

  useEffect(() => {
    const OptChennel = 'salesChannel';
    if (salesChannelFilterData && salesChannelFilterData.length > 0) {
      if (
        orderData?.modal?.data?.length > 0
      ) {
        setData(
          orderData.modal.data.filter(
            x =>
              salesChannelFilterData?.length > 0 &&
              salesChannelFilterData?.find(y => (y?.value?.toString() || '')?.toLowerCase()
                === x[OptChennel]?.toLowerCase()),
          ),
        );
      }
    } else {
      setData(orderData && orderData.modal && orderData.modal.data || []);
    }
  }, [orderData, salesChannelFilterData])

  productdata.sort((a, b) =>
    a?.key?.toLowerCase() > b?.key?.toLowerCase() ? 1 : -1)?.map(item => (
      skuOption.push({ label: item.key, value: item.key })
    ));

  productdata.sort((a, b) =>
    a?.prouctName?.toLowerCase() > b?.prouctName?.toLowerCase() ? 1 : -1)?.map(item => (
      productNameOptions.push({ label: item.prouctName, value: item.prouctName })
    ));

  return (
    <Container>
      <Card className="pb-3">
        <CardBody className="dashboard__card-widget card-shadow p-3">
          <CardTitle className="bold-text text-center" tag="h3">
            {vendorNameMapping[vendor]} Orders
          </CardTitle>
          <Row className="justify-content-space-between align-items-center mb-0 mt-0">
            <Col sm="2" md="2">
              <div className="form__form-group">
                <div className="form__form-group-field">
                  <TextField
                    id="amazonOrderId"
                    label="Enter Amazon OrderID "
                    value={searchAmazonOrderId}
                    onChange={event => setAmazonOrderId(event.target.value)}
                    margin="normal"
                  />

                </div>

              </div>
            </Col>
            <Col sm="2" md="2">
              <div className="form__form-group">
                <div className="form__form-group-field">
                  <TextField
                    id="buyerName"
                    label="Enter Buyer Name "
                    value={searchBuyerName}
                    onChange={event => setBuyerName(event.target.value)}
                    margin="normal"
                  />

                </div>

              </div>
            </Col>

            <Col sm="2" md="2">
              <div className="form__form-group">
                <div className="form__form-group-field">
                  <TextField
                    id="SKU"
                    select
                    label="Select SKU"
                    value={searchSKU}
                    onChange={changeSkuFilter}
                    SelectProps={{
                      native: true,
                    }}
                  >
                    <option key="" value="">
                      {/* None */}
                    </option>
                    {skuOption.map((item, index) => (
                      // eslint-disable-next-line react/no-array-index-key
                      <option key={`${item.value}-${index}`} value={item.value}>
                        {item.label}
                      </option>
                    ))}
                  </TextField>
                </div>

              </div>
            </Col>
            <Col sm="2" md="2">
              <div className="form__form-group">
                <div className="form__form-group-field">
                  <TextField
                    id="productName"
                    select
                    label="Select Product Name"
                    value={searchProductName}
                    onChange={changePNameFilter}
                    SelectProps={{
                      native: true,
                    }}
                  >
                    <option key="" value="">
                      {/* None */}
                    </option>
                    {productNameOptions.map((item, index) => (
                      // eslint-disable-next-line react/no-array-index-key
                      <option key={`${item.value}-${index}`} value={item.value}>
                        {item.label}
                      </option>
                    ))}
                  </TextField>
                </div>

              </div>
            </Col>
            <Col sm="4" className="p-0 filter-to-position">
              <button className="btn btn-sm btn-primary
                                             apply-date-button"
                type="button" onClick={handleApplySearch}>
                Apply</button>
                <button className="btn btn-sm btn-primary
                                             apply-date-button"  type="button"
                                             title='Export to pdf' disabled={isLoading}
                                    onClick={exportToPDF}>Export PDF</button>
                                    <button className="btn btn-sm btn-primary
                                             apply-date-button"
                type="button" onClick={uploadExcel}>
                Import</button>
            </Col>            
          </Row>
        </CardBody>
      </Card>
      <div id="divToPrint" ref={container}>
      <Row className="product-table-wrap">
        {isLoading ? (
          <Col sm="12">
            <CardBody>
              <div
                style={{ minHeight: '300px' }}
                className="row align-items-center justify-content-center"
              >
                <SmallLoader loading={isLoading} />
              </div>
            </CardBody>
          </Col>
        ) : (
          <>
            <div className="ExcelTable" id='dvTable'>
              <div 
                className="btn btn-primary btn-sm download"
                onClick={exportToExcel}
                style={{ 
                  cursor: !orderdata?.length ? 'not-allowed' : 'pointer',
                  opacity: !orderdata?.length ? 0.6 : 1 
                }}
              >
                <span className="action-title">Download</span>
              </div>
            </div>
            <OrderTable data={orderdata} pageInfo={orderData?.paginationInfo}
              callback={callApi} isTableLoading={isTableLoading} />
          </>)}

      </Row>
      </div>
    </Container>
  )
};

Order.propTypes = {
  dispatch: PropTypes.func.isRequired,
  vendor: PropTypes.number.isRequired
}

export default connect(state => ({
  rtl: state.rtl,
}))(Order);